var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNueve(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75927 1.55538C10.6172 2.37337 10.5722 3.81332 10.5722 3.81332C10.5722 3.81332 9.13612 3.92692 8.27803 3.10893C7.41994 2.29099 7.46507 0.850989 7.46507 0.850989C7.46507 0.850989 8.90142 0.738129 9.75927 1.55538V1.55538Z",
    stroke: "#A3B18A",
    strokeWidth: 1.44637,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91679 8.49713C6.44016 9.6318 6.64797 11.9311 6.64797 11.9311C6.64797 11.9311 4.38564 12.3904 2.86198 11.2557C1.33832 10.1211 1.1308 7.82179 1.1308 7.82179C1.1308 7.82179 3.39372 7.36359 4.91679 8.49713V8.49713Z",
    stroke: "#A3B18A",
    strokeWidth: 1.44637,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3506 19.4534C10.076 20.176 7.74622 18.6177 7.74622 18.6177C7.74622 18.6177 9.10498 15.8876 11.3798 15.1646C13.6546 14.4416 15.9842 16.0004 15.9842 16.0004C15.9842 16.0004 14.624 18.7302 12.3506 19.4534Z",
    stroke: "#A3B18A",
    strokeWidth: 1.44637,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7838 10.2437C13.9813 10.7611 12.1859 9.48579 12.1859 9.48579C12.1859 9.48579 13.3133 7.37153 15.1159 6.85385C16.9186 6.33616 18.7139 7.61181 18.7139 7.61181C18.7139 7.61181 17.5853 9.72586 15.7838 10.2437Z",
    stroke: "#A3B18A",
    strokeWidth: 1.44637,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2734 5.35535C11.2734 7.71244 9.84892 10.318 8.86553 11.8358C8.46421 12.4553 8.00808 13.0331 7.53217 13.5973C6.26186 15.1035 4.95548 17.6508 5.62026 21.4263",
    stroke: "#A3B18A",
    strokeWidth: 1.44637,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNueve);
export default __webpack_public_path__ + "static/media/iconNueve.20daff0a636cdeadb40d3973f0d4b546.svg";
export { ForwardRef as ReactComponent };